export enum SearchParameterTypeEnum {
  SWITCH = 'switch',
  ARRAY = 'array',
  GPS_DISTANCE = 'gps+distance',
  TEXT = 'text',
  DATE = 'date-range',
  RANGE = 'range',
}

export enum SearchParameterKeysTypeEnum {
  SEARCH_TEXT = 'search_text',
  DATE_RANGE = 'date_range',
  WHERE = 'where',
  WHERE_GPS = 'where[gps]',
  WHERE_DISTANCE = 'where[distance]',
  WHERE_ZONE = 'zone',
  BIKE_OR_WALK = 'bike_or_walk',
  BIKE_RENTAL = 'bike_rental',
  V1 = 'v1',
  GROUP = 'group',
  SERVICES = 'services',
  REGION = 'region',
  PLACE_TYPE = 'place_type',
  WITH = 'with',
  WHEN = 'when',

  TYPOLOGY = 'typology',
  INTEREST = 'interest',
}

export enum VersionEnum {
  V1 = 'v1',
  BV = 'bv',
  V2 = 'v2',
}
